/* ===========================================================
   panels/Conflicts.jsx — offline edits that met someone else's

   Shown when this device came back online and someone had changed the
   same spots meanwhile. Both versions are already in the doc (nothing
   lost); this lets the person pick, in plain words.
   =========================================================== */

import { useState } from 'preact/hooks';
import { Dialog, Button, Icon, openModal, toast } from '../ui/ui.jsx';
import { ConflictList } from './Merge.jsx';

function ReviewBox({ sync, rec, done }) {
  const [choices, setChoices] = useState({});
  const apply = async () => {
    const missed = await sync.resolveConflicts(choices);
    toast(missed.length ? 'Done. A couple of spots were edited again since, so I left those as they are.' : 'Done. Thanks for sorting that out!');
    done(true);
  };
  return (
    <Dialog title="Pick which changes to keep" wide onClose={() => done(false)}
      actions={<><Button onClick={() => done(false)}>Later</Button><Button kind="primary" onClick={apply}>Keep my choices</Button></>}>
      <p class="lead">While you were offline, someone else changed the same {rec.conflicts.length === 1 ? 'spot' : `${rec.conflicts.length} spots`}. Right now the doc has both versions, one after the other.</p>
      <ConflictList conflicts={rec.conflicts} choices={choices} setChoices={setChoices}
        labels={{ ours: 'Keep the online one', theirs: 'Keep mine', oursHead: 'Online version', theirsHead: 'Your offline version' }} />
    </Dialog>
  );
}

export function ConflictBanner({ sync, rec, onDone }) {
  const review = async () => { if (await openModal(done => <ReviewBox sync={sync} rec={rec} done={done} />)) onDone(); };
  return (
    <div class="banner warn" role="alert">
      <Icon name="info" size={16} />
      <span>You and someone else changed the same {rec.conflicts.length === 1 ? 'spot' : `${rec.conflicts.length} spots`} while you were offline. I kept both versions.</span>
      <span class="grow" />
      <Button size="sm" kind="primary" onClick={review}>Choose what to keep</Button>
      <Button size="sm" onClick={async () => { await sync.store.clearConflicts(sync.id); onDone(); }}>Keep both</Button>
    </div>
  );
}
